<ng-container *ngIf='content'>
  <div class='info-section'>
    <header class='hero hero-bleed'>
      <div class='hero-text'>
        <h1 class='hero-heading' *ngIf='content.mainTitle'>
                <span class='hero-kicker' *ngIf='content.subMainDescription'
                      [innerHTML]='content.subMainDescription'></span>
          <span class='hero-heading' [innerHTML]='content.mainTitle'></span>
        </h1>

        <div class='intro' [innerHTML]='content.mainDescription'></div>

        <a id="main-button-overwritten" class='hero-cta cta-ghost cta-big' [routerLink]='content.searchLink'>
          <svg>
            <use href='#dwg-icon-house'></use>
          </svg>
          <span [innerHTML]='content.searchLinkText'></span>
        </a>

        <a id="secondary-button-overwritten" class='hero-cta cta-ghost cta-big' [routerLink]='content.formLink'>
          <svg>
            <use href='#dwg-icon-form'></use>
          </svg>
          <span [innerHTML]='content.formLinkText'></span>
        </a>
      </div>
      <dwg-video-teaser
          class='hero-media'
          [image]='content.mainImage'
          [videoSrc]='content.video'
      ></dwg-video-teaser>
    </header>
  </div>

  <div class='main-content'>
    <div class='main-content-container'>
      <article class='info-box' *ngIf='!hideNotice'>
        <div class='info-box-image-container'>
          <ed-clients-lazy-bb-picture class='info-box-image' width='105' height='112'
                                   [blackbirdImage]='content.noticeImage'>
          </ed-clients-lazy-bb-picture>
        </div>

        <div class='info-box-title' [innerHTML]='content.noticeAddress'></div>

        <button class='info-box-close-button' (click)='closeNotice()'>schließen</button>

        <div class='info-box-message'>
          <div [innerHTML]='content.noticeMessage'></div>
        </div>
      </article>

      <div class='text-image text-image-find-contact'>
        <div class='text-image-image-container'>
          <ed-clients-lazy-bb-picture
              class='text-image-image'
              [blackbirdImage]='content.mainSectionImage'
          ></ed-clients-lazy-bb-picture>
        </div>
        <div class='text-image-text'>
          <h2 class='text-image-heading' [innerHTML]='content.mainSectionHeading'></h2>
          <div class='text-image-description' [innerHTML]='content.mainSectionDescription'></div>

          <div class='find-contact' [class.add-bottom-margin]="realEstates.length === 0">
            <dwg-find-contact
                [heading]='content.serviceBoxHeading'
                [serviceBoxItems]='content.serviceBoxItems'
                [allContactPersons]="allContactPersons"
            ></dwg-find-contact>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class='our-offers-section' *ngIf="realEstates.length > 0">
    <div class='our-offers-container'>
      <h2 class='our-offers-headline'>
        <span class='kicker' [innerHTML]='content.topOffersHeading'></span>
        <span class='heading' [innerHTML]='content.topOffersDescription'></span>
      </h2>

      <div class='real-estate-teaser-slider'>
        <ed-clients-dynamic-components-rendering
            [renderingItems]='dynamicData'></ed-clients-dynamic-components-rendering>

        <div class='real-estate-teaser-slider-controls'>
          <button class='real-estate-teaser-slider-control real-estate-teaser-slider-control--previous'
                  (click)='navigateBack()'>
            <svg class='real-estate-teaser-slider-control-icon'>
              <use href='#dwg-icon-east'></use>
            </svg>
          </button>
          <button class='real-estate-teaser-slider-control real-estate-teaser-slider-control--next'
                  (click)='navigateForward()'>
            <svg class='real-estate-teaser-slider-control-icon'>
              <use href='#dwg-icon-west'></use>
            </svg>
          </button>
        </div>
      </div>

      <div class='our-offers-more'>
        <a routerLink='/angebote' class='cta-ghost'>
          <span>Mehr Inserate anzeigen</span>
          <svg>
            <use href='#dwg-icon-load-more'></use>
          </svg>
        </a>
      </div>
    </div>
  </div>

  <div class='posts-container' *ngIf='posts.length > 0'>
    <div class='posts-header'>
      <h3 class='posts-heading'>Neuigkeiten & wichtige Informationen</h3>

<!--      <dwg-posts-filter-->
<!--          class='posts-filter'-->
<!--          searchInputPlaceholder='Suche'-->
<!--          [posts]='posts'-->
<!--          (filterChange)='onPostsFilterChange($event)'-->
<!--      ></dwg-posts-filter>-->
    </div>

    <dwg-posts-list
        class='posts-list'
        linkText='Mehr erfahren'
        loadMoreText='Weitere News'
        [posts]='filteredPosts'
        [displayLimit]='6'
        [loadMoreDisplayLimit]='1'
        [hideLoadMoreButton]="true"
        *ngIf="filteredPosts.length > 0; else noFilteredPostsFound"
    ></dwg-posts-list>

    <ng-template #noFilteredPostsFound>
<!--      <div class='posts-list no-posts-found'>-->
<!--        Keine Neuigkeiten gefunden-->
<!--      </div>-->
    </ng-template>

<!--    *ngIf="posts.length > 6"-->
    <div class='posts-footer' *ngIf="posts.length > 0">
      <a class='load-more-button cta-ghost' routerLink='/neuigkeiten-info'>
        <span class='load-more-caption'>Weitere News</span>
        <svg>
          <use href='#dwg-icon-load-more'></use>
        </svg>
      </a>
    </div>
  </div>

  <div class='marketing-data-section' *ngIf="content.marketingDataHeading && marketings">
    <div class='marketing-data-container'>
      <h2 class='marketing-data-heading' [innerHTML]='content.marketingDataHeading'></h2>
      <dwg-marketing-data [marketings]='marketings'></dwg-marketing-data>
    </div>
  </div>
</ng-container>
